import { useSelector } from 'react-redux'

const useHasPermission = (permission) => {
  const { rolPer } = useSelector((state) => state.rolesPermission)
  const { userInfo } = useSelector((state) => state.admin2faLogin)

  if (!rolPer?.data || !Array.isArray(rolPer.data)) return false

  const userRoleName = userInfo?.user?.role
  const userRoleId = userInfo?.user?.role_id ?? userInfo?.user?.roleId

  const userRole = rolPer.data.find(
    (r) => r.name === userRoleName || (userRoleId !== undefined && r.id === userRoleId)
  )

  if (!userRole?.permissions) return false

  return userRole.permissions.some(
    (p) => p.name === permission && p.is_active === true
  )
}

export default useHasPermission
